"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToolbarMenuState = void 0;
const OpenPanelState_1 = require("../../ContextMenu/ContextMenu/OpenPanelState");
const rxjs_1 = require("rxjs");
const selected$ = new rxjs_1.BehaviorSubject('');
class ToolbarMenuState {
    constructor(props, prefix = '') {
        this.props = props;
        this.execute = (item, event) => {
            const id = item.id ?? item.name;
            this.openPanel.onClick(id);
            if (item.onSelect) {
                item.onSelect(event);
                this.onclose?.();
            }
        };
        this.openPanel = new OpenPanelState_1.OpenPanelState({ selected$, prefix: prefix ? prefix + ':' : '', armed: true });
    }
}
exports.ToolbarMenuState = ToolbarMenuState;
